import EnbNaveMobi from "./Nave/EnbNaveMobi"
import SideNaveMobi from "./Nave/SideNaveMobi"
import SideBottom from "./SideBottom/SideBottom"
import SideNaveMobiPainel from './Nave/SideNaveMobiPainel'
import EnbNaveMobiPainel from "./Nave/EnbNaveMobiPainel"

export default {
  EnbNaveMobi,
  SideNaveMobi,
  SideBottom,
  EnbNaveMobiPainel,
  SideNaveMobiPainel
}
